"use client";
import { Box, Button, Typography, Container } from '@mui/material';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useIsLoggedIn } from "@/lib/hooks/useIsLoggedIn";

export default function HeroSection() {
  const t = useTranslations('Hero');
  const router = useRouter();
  // 获取用户登录状态
  const isLoggedIn = useIsLoggedIn();

  const handleGetStarted = () => {
    // 根据登录状态进行不同的路由跳转
    if (isLoggedIn) {
      // 已登录用户跳转到图表页面
      router.push('/products/analytics');
    } else {
      // 未登录用户跳转到注册页面
      router.push('/auth/signup');
    }
  };

  return (
    <Box sx={{ 
      pt: {xs: 4.5, sm: 12},
      pb: {xs: 10, sm: 12},
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: {xs: 3, md: 4},
      bgcolor: 'background.default',
      color: 'text.primary',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      'html[data-theme="dark"] &': {
        backgroundImage: 'url(/images/hero-bg-dark.png)',
      },
      'html[data-theme="light"] &': {
        backgroundImage: 'url(/images/hero-bg-light.png)',
      },
    }}>
      <Container maxWidth="lg" sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 0 },
      }}>
        {/* Text Content */}
        <Box sx={{ width: { xs: "100%", md: "50%" }, textAlign: { xs: "center", md: "left" } }}>
          <Typography 
            variant="h2" 
            sx={{ fontSize: "var(--font-size-6xl)", fontWeight: 600, mb: {xs: 2, sm: 3} }}
          >
            {t.rich('title', {
              strong: (children) => (
                <Typography 
                  component="span" 
                  color="primary.main" 
                  variant="inherit" 
                  sx={{ display: 'inline', fontWeight: 600 }}
                >
                  {children}
                </Typography>
              )
            })}
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              fontSize: "var(font-size-l)", 
              color: 'text.secondary', 
              opacity: 0.8, 
            }}
          >
            {t.rich('subtitle', {
              br: () => <br />
            })}
          </Typography>
          <Button 
            variant="contained" 
            sx={{
              bgcolor: 'primary.main',
              color: '#FFFFFF',
              mt: {xs: 4.5, sm: 3},
              mb: {xs: 4.5, sm: 0},
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'primary.dark',
              }
            }}
            onClick={handleGetStarted}
          >
            {t('getStarted')}
          </Button>
        </Box>

        {/* Image */}
        <Box sx={{ position: "relative", width: { xs: "100%", md: "50%" } }}>
          <div style={{ position: 'relative', width: '100%', height: 'auto', maxWidth: '100%' }}>
            <Image className="themed-img-dark" src="/images/dark-chart.apng" alt="Hero Image" width={500} height={500} style={{ width: '100%', height: 'auto', maxWidth: '100%' }} unoptimized />
            <Image className="themed-img-light" src="/images/light-chart.apng" alt="Hero Image" width={500} height={500} style={{ width: '100%', height: 'auto', maxWidth: '100%' }} unoptimized />
            <Image className="themed-img-dark" src="/images/dark-coin.apng" alt="Hero Image" width={500} height={500} style={{ width: '100%', height: 'auto', maxWidth: '100%', position: 'absolute', top: 0 }} unoptimized />
            <Image className="themed-img-light" src="/images/light-coin.apng" alt="Hero Image" width={500} height={500} style={{ width: '100%', height: 'auto', maxWidth: '100%', position: 'absolute', top: 0 }} unoptimized />
          </div>
        </Box>
      </Container>
    </Box>
  );
}